import { render } from "./Seasons.vue?vue&type=template&id=bafd0774"
import script from "./Seasons.vue?vue&type=script&lang=js"
export * from "./Seasons.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__